export default __webpack_public_path__ + "svg/CompaniesLogos/logo_lideres-y-digitales.svg?e7febccb";